import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { EmbedService } from '../../../../embed-layout/common/services/embed.service';
import { Subject, takeUntil } from 'rxjs';
import { EmbedData } from '../../data/embed';

@Component({
  selector: 'selected-project-list-controller',
  imports: [MatIconModule],
  templateUrl: './selected-project-list-controller.component.html',
  styleUrl: './selected-project-list-controller.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedProjectListControllerComponent implements OnInit, OnDestroy {
  public embedData: EmbedData | undefined;

  public selectedProjectIndex: number = 0;

  private unsubscribeAll: Subject<any> = new Subject();
  constructor(
    private embedService: EmbedService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getEmbedData();
    this.getSelectedProjectIndex();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  public onClickNextProject(): void {
    this.embedService.selectedProejctIndex += 1;
  }

  public onClickPreviousProject(): void {
    this.embedService.selectedProejctIndex -= 1;
  }

  private getEmbedData(): void {
    this.embedService.embedData$.pipe(takeUntil(this.unsubscribeAll)).subscribe((embedData) => {
      if (!embedData) return;
      this.embedData = embedData;
      this.cd.markForCheck();
    });
  }

  private getSelectedProjectIndex(): void {
    this.embedService.selectedProjectIndex$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((index) => {
        this.selectedProjectIndex = index;
        this.cd.markForCheck();
      });
  }
}
